import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { animate, state, style, transition, trigger } from '@angular/animations';
import * as Highcharts from 'highcharts';
import { QuantiteDossierByEmployeeDTO } from 'src/app/new-dashboard/core/model/quantite-dossier-by-employee-dto';
import { NewDashboardProfessionnelService } from 'src/app/new-dashboard/core/service/new-dashboard-professionnel.service';
import { QuantiteDossierPortefeuilleParProfileDTO } from 'src/app/new-dashboard/core/model/quantite-dossier-portefeuille-par-profile-dto';
import { DashboardAllMarcheService } from 'src/app/new-dashboard/core/service/dashboard-all-marche.service';
import { QuantiteDossierPortefeuilleParDepartementDTO } from 'src/app/new-dashboard/core/model/quantite-dossier-portefeuille-par-departement-dto';
import { Bank } from 'src/app/parametrage/core/model/bank';
import { City } from 'src/app/parametrage/core/model/city';
import { RequestService } from 'src/app/parametrage/core/service/request.service';
import { BankService } from 'src/app/parametrage/core/service/bank.service';
import { CityService } from 'src/app/parametrage/core/service/city.service';
import { Request } from 'src/app/parametrage/core/model/request';

@Component({
  selector: 'app-prof-productivite',
  templateUrl: './prof-productivite.component.html',
  styleUrls: ['./prof-productivite.component.scss'],
  
  //
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
  //

})
export class ProfProductiviteComponent implements OnInit {

  cityFilter: String = "_";
  bankFilter: String = "_";

  banks: Bank[];
  cities: City[];

  //employee
  displayedEmployeeColumnsList: string[] = ['username', 'firstname', 'lastname', 'poste', 'quantiteDossierEnCours', 'quantiteDossierEnRetard', 'quantiteDossierTraite', 'pourcentageDossierEnRetard', 'actions'];
  quantiteDossierByEmployeeDTOs : QuantiteDossierByEmployeeDTO[];

  dossierHistoryArray:Array<Request[]> = [];
  pageHistory:number = 1;
  totalElementsHistory:number = 0;
  filterHistory: String = "";
  //
  
  //depratement
  displayedDepartementColumnsList: string[] = ['departement', 'nombreDossierEnCours', 'nombreDossierValide', 'nombreDossierACorriger', 'actions'];
  dossiersDepartements : QuantiteDossierPortefeuilleParDepartementDTO[];
  expandedElement2: QuantiteDossierPortefeuilleParDepartementDTO | null;

  dossiersProfilesArray : Array<QuantiteDossierPortefeuilleParProfileDTO[]> = [];
  //


  highcharts = Highcharts;
  //chartOptionsRankingEncours:any;
  //chartOptionsRankingMiseEnPlace:any;


  constructor(
    private _newDashboardProfessionnelService : NewDashboardProfessionnelService,
    private _dashboardAllMarcheService : DashboardAllMarcheService,
    private _requestService : RequestService,
    private _bankService: BankService,
    private _cityService: CityService
    ) 
    {}


  ngOnInit() {
    this.getAllCities();
    this.getAllBanksByCity("_");
    this.quantiteDossierByEmployee("_");
    //this.rankingTacheEnCours("_");
    //this.rankingTacheMiseEnPlace("_");
    this.portefeuilleTachesParMarche("_");
  }

  
 getAllCities()
 {
    this._cityService.getAllCities()
    .pipe(first())
    .subscribe(
        data => {
            this.cities = data;
        },
        error => {
            console.log(error);
        });
 }

 getAllBanksByCity(city)
 {
    this._bankService.getAllBanksByCity(city)
    .pipe(first())
    .subscribe(
        data => {
            this.banks = data;
            this.bankFilter = "_";
        },
        error => {
            console.log(error);
        });
 }

 refresh(codeAgence)
 {
  this.bankFilter = codeAgence;
  this.quantiteDossierByEmployee(codeAgence);
  //this.rankingTacheEnCours(codeAgence);
  //this.rankingTacheMiseEnPlace(codeAgence);
  this.portefeuilleTachesParMarche(codeAgence);
 }

  
  
quantiteDossierByEmployee(codeAgence)
{
  this._newDashboardProfessionnelService.quantiteDossierByEmployee(codeAgence)
  .pipe(first())
  .subscribe(
      response => {
        this.quantiteDossierByEmployeeDTOs = response;
      },
      error => {
        console.log(error);
      });
}

  
getRequestsHistoryByWorkflowAndUsername(username,filter,page,size)
{
      this._requestService.getRequestsHistoryByWorkflowAndUsername("PROFESSIONNEL",filter,username,"_","","",page,size,"id","desc")
      .pipe(first())
      .subscribe(
          data => {
              this.dossierHistoryArray[username] = data.content;
              this.totalElementsHistory = data.totalElements;
          },
          error => {
              console.log(error);
          });
}
//



//
portefeuilleTachesParMarche(codeAgence)
{
  this._dashboardAllMarcheService.portefeuilleTachesParMarche("PROFESSIONNEL",codeAgence)
  .pipe(first())
  .subscribe(
      response => {
        this.dossiersDepartements = response;
      },
      error => {
        console.log(error);
      });
}

portefeuilleTachesParDepartement(codeDepartement) {
  this._dashboardAllMarcheService.portefeuilleTachesParDepartement("PROFESSIONNEL",this.bankFilter, codeDepartement).subscribe(
    (data: QuantiteDossierPortefeuilleParProfileDTO[]) => {
      console.log(data);
      this.dossiersProfilesArray[codeDepartement] = data; 
    });
}
//

/*
rankingTacheEnCours(codeAgence)
{
  
    this._dashboardAllMarcheService.rankingGestionnaireParMarche("PROFESSIONNEL",codeAgence,"ENCOURS")
    .pipe(first())
    .subscribe(
        data => {
            const series = [];
            const categories = data.map(item => item.name);
            const seriesData =  data.map(item => item.valeur);
            series.push({name: "EnCours", data: seriesData});
            
            this.chartOptionsRankingEncours = {   
              chart: {
                type: 'bar'
              },
              title: {
                 text: 'Dossiers en cours par gestionnaire'
              },
              subtitle : {
                 text: null 
              },
              legend : {
                 layout: 'vertical',
                 align: 'right',
                 verticalAlign: 'top',
                 //x: 250,
                 y: 100,
                 floating: false,
                 borderWidth: 1,
                 backgroundColor: ('#FFFFFF'),
                 shadow: true
                 },
                 xAxis:{
                    categories: categories, 
                    title: {
                    text: null
                 } 
              },
              yAxis : {
                 min: 0, title: {
                    text: 'Qte dossier', align: 'high'
                 },
                 labels: {
                    overflow: 'justify'
                 }
              },
              tooltip : {
                 valueSuffix: ' Qte'
              },
              plotOptions : {
                 bar: {
                    dataLabels: {
                       enabled: true
                    },
                    showInLegend: true
                 },
                 series: {
                    stacking: 'normal'
                 }
              },
              credits:{
                 enabled: false
              },
              series: series
           };

        },
        error => {
            console.log(error);
        });
}



rankingTacheMiseEnPlace(codeAgence)
{
  
    this._dashboardAllMarcheService.rankingGestionnaireParMarche("PROFESSIONNEL",codeAgence,"MISEENPLACE")
    .pipe(first())
    .subscribe(
        data => {
            const series = [];
            const categories = data.map(item => item.name);
            const seriesData =  data.map(item => item.valeur);
            series.push({name: "Mise en place", data: seriesData});
            
            this.chartOptionsRankingMiseEnPlace = {   
              chart: {
                type: 'bar'
              },
              title: {
                 text: 'Dossiers mis place par gestionnaire'
              },
              subtitle : {
                 text: null 
              },
              legend : {
                 layout: 'vertical',
                 align: 'right',
                 verticalAlign: 'top',
                 //x: 250,
                 y: 100,
                 floating: false,
                 borderWidth: 1,
                 backgroundColor: ('#FFFFFF'),
                 shadow: true
                 },
                 xAxis:{
                    categories: categories, 
                    title: {
                    text: null
                 } 
              },
              yAxis : {
                 min: 0, title: {
                    text: 'Qte dossier', align: 'high'
                 },
                 labels: {
                    overflow: 'justify'
                 }
              },
              tooltip : {
                 valueSuffix: ' Qte'
              },
              plotOptions : {
                 bar: {
                    dataLabels: {
                       enabled: true
                    },
                    showInLegend: true
                 },
                 series: {
                    stacking: 'normal'
                 }
              },
              credits:{
                 enabled: false
              },
              series: series
           };

        },
        error => {
            console.log(error);
        });
}
*/

}
